/**
 * Created by Kris Frenz on 11.08.17.
 */

import $ from 'jquery';

class EmbeddedVideo {
	/**
	 * Takes Video OuterHML
	 * @param videoSection
	 */
	constructor(videoSection) {
		this.videoSection = $(videoSection);
		this.playButton = $('.cmp-01-stage__play-button');
		this.closeButton = $('.cmp-01-stage__close-button');
		this.videoWrapper = $('.video__responsive');
		this.isVisible = 'is-visible';
		this.videoIframe = '<iframe width="560" height="315" src="https://www.youtube.com/embed/2mmbABfXG9k" frameborder="0" allowfullscreen></iframe>';
		this.playVideo();
		this.closeVideo();
		this.documentFocus();
	}

	/**
	 * Plays Video and loads iframe
	 */
	playVideo() {
		this.playButton.on('click', () => {
			this.videoSection.addClass(this.isVisible);
			this.videoWrapper.html(this.videoIframe);
		});
	}

	/**
	 * Closes overlay and removes iframe
	 */
	closeVideo() {
		this.closeButton.on('click', () => {
			this.videoSection.removeClass(this.isVisible);
			this.videoWrapper.html('');
		});
	}

	/**
	 * Closes overlay and removes iframe
	 */
	documentFocus() {
		$(document).on(
			'touchend, mouseup',
			(event) => {
				if (this.videoSection.is(event.target)) {
					this.closeVideo();
				}
			});
	}

}

export default EmbeddedVideo;



// WEBPACK FOOTER //
// ./js/modules/embeddedVideo.js